import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "My brain is a vector",
  "description": "",
  "published": "2008-03-26T00:00:00.000Z",
  "redirect_from": ["/blog/my-brain-is-a-vector/swizec/120"],
  "categories": "life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`I was studying linear algebra all night last night. Until five in the morning in fact and then because I couldn't quite get myself to sleep I watched sitcoms until six. Yes quite insane. Why is it that I couldn't sleep after something like eight hours of studying? Probably because my mind's gone crazy and turned into vectory mush.`}</p>
    <p>{`When I woke today at 11 the first thing I saw was the laptop blabbing sitcoms in my face so what'd I do? Complain to the first random person on MSN ... it's what geeks do. Honestly, it felt like I was having a studying hangover, how the hell did that happen? Never had a hangover from studying before ...`}</p>
    <p>{`You know what, not that I was having a hangover ... I think I still am and the sad part is how I'm facing another three or four hours of studying this bloody linear algebra so I can then go to the last minute preparations at school and then, lo and behold, take the midterm.`}</p>
    <p>{`I'm overrun with joyous joy and exquisite ecstasy ... yay woo, linear algebraic algebraism in three dimensional space.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      